<template>
  <div class="staff-list-container">
    <div class="page-header">
      <div class="breadcrumb">ພະນັກງານ / <span>ລາຍຊື່ຄູອາຈານ ແລະ ພະນັກງານ</span></div>
      <div class="header-content">
        <h1>ລາຍຊື່ຄູອາຈານ ແລະ ພະນັກງານ</h1>
        
        <button v-if="hasBit($route.query.id, 1)" class="btn-primary" @click="$router.push('/home/staff/new')">
          <i class="fas fa-user-plus"></i> ເພີ່ມພະນັກງານໃໝ່
        </button>
      </div>
    </div>
 
    <div class="panel filter-panel">
      <div class="panel-head">
        <h3><i class="fas fa-search"></i> ຄົ້ນຫາຄູ ແລະ ພະນັກງານ</h3>
      </div>
      <div class="panel-body">
        <div class="search-box">
          <div class="input-container">
            <i class="fas fa-search search-icon"></i>
            <input 
              type="text" 
              v-model="searchQuery" 
              placeholder="ຄົ້ນຫາດ້ວຍ ຊື່, ນາມສະກຸນ ຫຼື ລະຫັດ..."
            >
          </div>
        </div>
      </div>
    </div>

    <div class="panel mt-4 table-panel">
      <div class="panel-body">
        <div class="table-wrap">
          <table class="staff-table">
            <thead>
              <tr>
                <th>ລຳດັບ</th>
                <th>ລະຫັດຄູ</th>
                <th>ຊື່ ແລະ ນາມສະກຸນ</th>
                <th>ເພດ</th>
                <th>ເບີໂທລະສັບ</th>
                <th>ລະຫັດໂຮງຮຽນ</th>
                <th>ສະຖານະ</th>
                <th class="text-center">ຈັດການ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loading">
                <td colspan="8" class="text-center py-4"><i class="fas fa-spinner fa-spin"></i> ກຳລັງໂຫຼດ...</td>
              </tr>
              <tr v-else v-for="(item, index) in staffList" :key="item._id">
                <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                <td><span class="asset-code">{{ item.teacher_code }}</span></td>
                <td class="asset-name">{{ item.First_Name }} {{ item.Last_Name }}</td>
                <td>{{ item.Gender === 'ຊ' || item.Gender === 'Male' ? 'ຊາຍ' : (item.Gender === 'ຍ' || item.Gender === 'Female' ? 'ຍິງ' : '-') }}</td>
                <td>{{ item.Mobile_number || '-' }}</td>
                <td>{{ item.school_id }}</td>
                <td>
                  <span :class="['status-pill', item['Active '] == 1 ? 'active' : 'lost']">
                    {{ item['Active '] == 1 ? 'ເປີດໃຊ້ງານ' : 'ປິດໃຊ້ງານ' }}
                  </span>
                </td>
                <td class="text-center">
                   <button v-if=" hasBit('staff-list', 1)" class="panel-action" @click="handleEdit(item)" title="ແກ້ໄຂ">✏️</button>
                  <button v-if="hasBit('staff-list', 2)" class="panel-action text-danger" @click="showConfirm(item)" title="ລົບ">🗑️</button>
                </td>
              </tr>
              <tr v-if="!loading && staffList.length === 0">
                <td colspan="8" class="text-center py-4">ບໍ່ມີຂໍ້ມູນພະນັກງານ</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="pagination-container">
        <div class="pagination-info">ສະແດງ {{ startItem }} - {{ endItem }} ຈາກທັງໝົດ {{ totalRows }} ລາຍການ</div>
        <div class="pagination-controls">
          <button class="page-btn" :disabled="currentPage === 1" @click="changePage(currentPage - 1)">«</button>
          <template v-for="(page, idx) in visiblePages">
            <span v-if="page === '...'" :key="'e' + idx" class="page-ellipsis">…</span>
            <button v-else :key="page"
                    class="page-btn"
                    :class="{ active: currentPage === page }"
                    @click="changePage(page)">{{ page }}</button>
          </template>
          <button class="page-btn" :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">»</button>
        </div>
      </div>
    </div>

    <!-- Modal ຢືນຢັນ (Confirm Modal) -->
    <transition name="modal">
      <div v-if="confirmModal.show" class="modal-overlay" @mousedown.self="confirmModal.show = false">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon warning">
            <i class="fas fa-exclamation-triangle"></i>
          </div>
          <div class="modal-content-area">
            <h2>ຢືນຢັນການລົບ</h2>
            <p>ທ່ານຕ້ອງການລົບພະນັກງານ <strong>{{ confirmModal.staffName }}</strong> ອອກຈາກລະບົບແມ່ນບໍ່?</p>
          </div>
          <div class="modal-footer-actions">
            <button class="btn-modal-secondary" @click="confirmModal.show = false">ຍົກເລີກ</button>
            <button class="btn-modal-primary error" @click="handleDelete">ຕົກລົງ, ລົບອອກ</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- Modal ແຈ້ງຜົນຮັບ (Result Modal) -->
    <transition name="modal">
      <div v-if="resultModal.show" class="modal-overlay" @mousedown.self="resultModal.show = false">
        <div class="custom-modal-card result-modal">
          <div class="modal-icon" :class="resultModal.type">
            <i class="fas" :class="resultModal.type === 'success' ? 'fa-check-circle' : 'fa-times-circle'"></i>
          </div>
          <div class="modal-content-area">
            <h2>{{ resultModal.title }}</h2>
            <p>{{ resultModal.message }}</p>
          </div>
          <div class="modal-footer-actions">
            <button 
              class="btn-modal-primary" 
              :class="resultModal.type" 
              @click="resultModal.show = false"
            >
              ເຂົ້າໃຈແລ້ວ
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import api from '@/utils/api';
import { getPaginationRange } from '@/utils/pagination';

export default {
  name: 'StaffListPage',
  data() {
    return {
      staffList: [],
      currentPage: 1,
      pageSize: 15,
      totalRows: 0,
      searchQuery: '',
      loading: false,
      user: {},
      searchTimer: null,
      confirmModal: { show: false, staffId: null, staffName: '' },
      resultModal: { show: false, type: 'success', title: '', message: '' },
      permissionState: {},
      permissionRecordId: null,
      loadingPermissions: false,
    };
  },
  watch: {
    searchQuery() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => { this.handleSearch(); }, 500);
    }
  },
  computed: {
    totalPages() { return Math.ceil(this.totalRows / this.pageSize) || 1; },
    visiblePages() { return getPaginationRange(this.currentPage, this.totalPages); },
    startItem() { return this.totalRows === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1; },
    endItem() { 
      const end = this.currentPage * this.pageSize;
      return end > this.totalRows ? this.totalRows : end;
    }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user-info") || "{}");
    this.fetchStaff();
    this.fetchRolePermissions(this.user.user_level);
  },
  methods: {
    async fetchStaff() {
      this.loading = true;
      try {
        const res = await api.get('/staff/all', {
          params: {
            page: this.currentPage,
            limit: this.pageSize,
            search: this.searchQuery,
            school_id: this.user.school_id
          }
        });
        if (res.data.code === 1) {
          this.staffList = res.data.rows;
          this.totalRows = res.data.totalRows;
        }
      } catch (e) { console.error(e); }
      finally { this.loading = false; }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchStaff();
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchStaff();
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleDateString('lo-LA');
    },
    handleEdit(item) {
      this.$router.push(`/home/staff/edit/${item._id}`);
    },
    showConfirm(item) {
      this.confirmModal = {
        show: true,
        staffId: item._id,
        staffName: `${item.First_Name} ${item.Last_Name}`
      };
    },
    showResult(type, title, message) {
      this.resultModal = { show: true, type, title, message };
    },
    async handleDelete() {
      const staffId = this.confirmModal.staffId;
      this.confirmModal.show = false;
      try {
        const res = await api.delete(`/del/teachers/${staffId}`);
        if (res.data.code === 1) {
          this.showResult('success', 'ລົບສຳເລັດ', 'ຂໍ້ມູນພະນັກງານຖືກລົບອອກຈາກລະບົບແລ້ວ');
          this.fetchStaff();
        } else {
          this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', res.data.desc || 'ບໍ່ສາມາດລົບຂໍ້ມູນໄດ້');
        }
      } catch (e) {
        this.showResult('error', 'ເກີດຂໍ້ຜິດພາດ', 'ບໍ່ສາມາດເຊື່ອມຕໍ່ກັບເຊີເວີໄດ້');
      }
    },
     async fetchRolePermissions(roleId) {
      this.loadingPermissions = true;
      try {
        const res = await api.get(`/getRowsInt/permissions/role_id/${roleId}`);
        console.log('Permissions response:', res.data);
        if (res.data && res.data.length > 0) {
          this.permissionState = res.data[0].permissions || {};
          this.permissionRecordId = res.data[0]._id;
        } else {
          // ຫາກບໍ່ພົບຂໍ້ມູນ ໃຫ້ຕັ້ງຄ່າເລີ່ມຕົ້ນ
          this.permissionRecordId = null;
          const defaults = {};
          this.menuGroups.forEach(group => {
            // ຕັ້ງຄ່າເລີ່ມຕົ້ນໃຫ້ກຸ່ມຫຼັກ
            defaults[group.id] = roleId === 1 ? 7 : 1;
            group.items.forEach(item => {
              // ຖ້າເປັນ Admin ໃຫ້ສິດເຕັມ (7), ຖ້າບໍ່ແມ່ນໃຫ້ສິດເບິ່ງຢ່າງດຽວ (1)
              defaults[item.id] = roleId === 1 ? 7 : 1;
            });
          });
          this.permissionState = defaults;
        }
      } catch (e) {
        console.error('Fetch permissions error:', e);
      } finally {
        this.loadingPermissions = false;
      }
    },
    hasBit(moduleKey, bit) {
      const val = this.permissionState[moduleKey] || 0;
      return (val & (1 << bit)) !== 0;
    },
  }
};
</script>

<style scoped>
.staff-list-container { animation: fadeIn 0.4s ease; }
.header-content { display: flex; justify-content: space-between; align-items: center; margin-top: 10px; }

.filter-panel { border-top: 4px solid var(--lao); margin-bottom: 0; }
.table-panel { border-radius: 12px; overflow: hidden; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05); }

.search-box { display: flex; gap: 10px; }
.input-container { position: relative; flex: 1; max-width: 400px; }
.search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--text3); }
.input-container input { width: 100%; padding: 10px 10px 10px 35px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; }

.btn-primary { background: var(--lao); color: white; border: none; padding: 10px 20px; border-radius: 8px; cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 8px; }

.table-wrap { max-height: 65vh; overflow-y: auto; border: 1px solid var(--border); border-radius: 8px; }
.staff-table { width: 100%; border-collapse: separate; border-spacing: 0; background: white; }
.staff-table th { 
  position: sticky; top: 0; background: #f8fafc; z-index: 10; padding: 15px 12px;
  text-align: left; font-size: 12px; color: var(--text1); font-weight: 700;
  border-bottom: 2px solid var(--border); text-transform: uppercase;
}
.staff-table td { padding: 12px; border-bottom: 1px solid #edf2f7; font-size: 14px; vertical-align: middle; transition: background 0.2s; }
.staff-table tr:hover td { background-color: #f8fafc; }
.staff-table tr:nth-child(even) { background-color: #fafafa; }

.asset-code { background: #e2e8f0; padding: 2px 8px; border-radius: 4px; font-family: 'IBM Plex Mono', monospace; font-size: 11px; font-weight: 600; color: #475569; }
.asset-name { font-weight: 600; color: var(--lao); font-size: 14.5px; }

.pagination-container { display: flex; justify-content: space-between; align-items: center; padding: 20px; border-top: 1px solid var(--border); }
.page-btn { padding: 5px 12px; border: 1px solid var(--border); background: white; border-radius: 4px; cursor: pointer; margin: 0 2px; }
.page-btn.active { background: var(--lao); color: white; border-color: var(--lao); }
.page-ellipsis { padding: 5px 6px; color: var(--text3); }

/* Modal Overlay Styling */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
}

/* Result & Confirm Modal Custom Styling */
.result-modal { padding: 40px 30px; max-width: 400px !important; text-align: center; background: white; border-radius: 16px; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.1); }
.modal-icon { font-size: 64px; margin-bottom: 20px; }
.modal-icon.success { color: #10b981; }
.modal-icon.error { color: #ef4444; }
.modal-icon.warning { color: #f59e0b; }

.modal-content-area h2 { margin: 0 0 10px; font-size: 1.6rem; color: #0f172a; font-weight: 800; }
.modal-content-area p { color: #334155; font-size: 1.05rem; line-height: 1.6; margin-bottom: 30px; font-weight: 500; }

.modal-footer-actions { display: flex; gap: 12px; justify-content: center; }

.btn-modal-primary {
  padding: 12px 24px; border: none; border-radius: 10px; cursor: pointer;
  font-weight: 600; font-size: 14px; background: var(--lao); color: white;
  transition: 0.2s; min-width: 140px;
}
.btn-modal-primary:hover { transform: translateY(-2px); box-shadow: 0 4px 12px rgba(0, 63, 138, 0.2); }
.btn-modal-primary.success { background: #10b981; }
.btn-modal-primary.success:hover { background: #059669; }
.btn-modal-primary.error { background: #ef4444; }
.btn-modal-primary.error:hover { background: #dc2626; }

.btn-modal-secondary {
  padding: 12px 24px; border: 1.5px solid #e2e8f0; border-radius: 10px;
  cursor: pointer; font-weight: 600; font-size: 14px; background: white;
  color: #475569; transition: 0.2s; min-width: 120px;
}
.btn-modal-secondary:hover { background: #f8fafc; color: var(--text1); }

/* Modal Animation */
.modal-enter-active, .modal-leave-active { transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
.modal-enter, .modal-leave-to { opacity: 0; }
.modal-enter-active .custom-modal-card { animation: modalIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); }
.modal-leave-active .custom-modal-card { animation: modalOut 0.2s ease-in; }

@keyframes modalIn {
  from { opacity: 0; transform: scale(0.8) translateY(20px); }
  to { opacity: 1; transform: scale(1) translateY(0); }
}

@keyframes modalOut {
  from { opacity: 1; transform: scale(1); }
  to { opacity: 0; transform: scale(0.9); }
}
</style>